import React, { useEffect } from "react";

function Logout() {
  useEffect(() => {
    localStorage.removeItem("redirectSession");
    window.location.href = "/login";
  }, []);

  return null;
}

export default Logout;
